import { Building2 } from 'lucide-react';

import CreateBeneficiaryDialog from './CreateBeneficiaryDialog';

const EmptyBeneficiary = () => {
  return (
    <div className="p-6 bg-white rounded-lg border border-dashed border-border text-center space-y-6 h-full flex flex-col justify-center items-center">
      <div className="size-12 bg-white rounded-md border border-border flex items-center justify-center mx-auto shadow-xs">
        <Building2 className="size-6 text-foreground" />
      </div>
      <CreateBeneficiaryDialog />
    </div>
  );
};

export default EmptyBeneficiary;
